module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch02"
    }
  }, [_c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Chapter Two")])])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "chapterOpenerFirstLetters"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("‘I")])]), _vm._v(" had not believed William capable of such unmannerly behaviour till I witnessed it with my own eyes this evening.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Alexander Pemberton shot his wife an ironic look. He dismissed the hovering servant with a weary hand-flick and discarded his overcoat on to a chair. Next he helped himself to the decanter. ‘I perceived nothing unreasonable in our son’s behaviour. I expect William considered a lack of gallantry appropriate tonight.’ Alexander helped himself to a generous measure of cognac.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Pamela Pemberton, shrugging out of her pelisse, swivelled towards her husband, her arms imprisoned and mouth momentarily motionless. ‘I’m sure I don’t know what you mean by that.’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_vm._v("‘I think you do, Pamela,’ Alexander said quietly before he sipped. ‘And I shall tell you something ")]), _c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_vm._v("else: I shall not be a party to your schemes. Please do not again manipulate me into dancing attendance upon Lady Bingham as though I, too, approve of her peculiar interest in my son…my son, who is happily married to a woman he adores.’ With unaffected chivalry Alexander helped his wife to extricate her arms from her coat and laid it aside for her.")])]), _c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Pamela snatched her satin sleeves about her in a way that her husband recognised, for it invariably presaged a tirade.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Alexander held up a silencing hand. ‘And before you say one word, I have several more of my own I would have you listen to. Do not treat William as you do me: as though he were still a green youth likely to be swayed by your nagging. It is very many years since I observed him doing as you say, simply for a little peace and quiet. If you continue to meddle in his life, you will drive him completely away. I would bet a florin to get a crown that he is planning with June to repair to the country for the rest of the season, just so they might avoid any further unpleasant atmosphere.’ Alexander cast a glance on his wife’s indignant countenance and, as always, part of him softened for part of him still loved her. Gently he said, ‘Do not underestimate William; he will not take kindly to being made to look a fool, Pamela.’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_vm._v("‘How dare you lecture me over my son! Do you think I know nothing of his character? Naturally I ")]), _c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_vm._v("want what is best for him. I have always wanted what is best for him.’")])]), _c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘If that is so, why are you helping to put him at risk of ridicule?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Ridicule? What are you talking about? "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Ridicule")]), _vm._v("?’ She illustrated her impatience and disbelief with a whirling hand.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Alexander slammed down his glass with unaccustomed temper. ‘Tonight I heard Harley and Darlington smirking over a wager they’ve made that concerned our son and Constance Bingham. Lord Harley has it that William will have her as a mistress before Whitsun. Lord Darlington favours Constance holding out for a better offer from him and thinks Michaelmas might be when there is talk of a divorce. I am not saying their slander was sincerely meant; rather they seek to be jesters. I would have had both of them outside and told them exactly what I thought of their pathetic jokes had there not been over a hundred people present to witness the ensuing chaos. I’m quite sure that our son and daughter-in-law are aware they are being made the butt of hurtful gossip. Harley and Darlington haunt all the clubs and parties.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Pamela had the grace to blush and stammer. ‘I…I don’t see how that is my fault. People have long memories. Obviously, some have remembered that William and Constance once were engaged…once they were in love.’")])]), _c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘If that is so, they must then also recall how enduring was her love for him. My own recollection is that, within a few months of my future daughter-in-law slipping on her engagement ring, she was replacing it with that flashy bauble Charlie Bingham gave her. Within an unconscionably short time she was Bingham’s wife. Let us not mince our words over this, Pamela: Constance Bingham was a gold digger. William was hardly a pauper himself at that time, yet she wanted more. He couldn’t give her a title, so with disrespectful haste she married a man who could.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘She was browbeaten by her family,’ Pamela quickly championed the widow. ‘I can understand their ambition. I own I was angry with her when the betrothal was broke. But she "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("is")]), _vm._v(" a baronet’s daughter. It was natural her family would have favoured a more advantageous match for her. Lord Bingham was very wealthy and influential…and a nice gentleman, of course. Naturally, at his age, he wanted a speedy marriage and a chance to sire a male heir. Unfortunately it was not to be, but he has left her a very attractive prospect, and a daughter to love.’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_vm._v("‘There is no nicer gentleman than our son,’ Alexander said exceedingly quietly. ‘Constance Bingham has had ample proof of it. If William were not such a courteous and tolerant character he would not give her the time of day, no matter what attractiveness or ")]), _c('a', {
    attrs: {
      "id": "page26"
    }
  }, [_vm._v("prospects she has. Do not help manoeuvre him into a situation, Pamela, where he is forced to relinquish his good manners to prove his love to his wife.’")])]), _c('a', {
    attrs: {
      "id": "page26"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘If June Meredith were a lady of proper refinement she would not make him act with incivility simply to flatter and placate her. She is behaving like a jealous minx, storming off like that when she knew we all were approaching to speak with him…and her. Why can she not conduct herself properly?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘She is acting in the manner of a wife who is being exposed to humiliation and scandal through no fault of her own. And William is acting, not before time, like a man who is done with seeing upset the wife he adores.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Pamela’s mouth pinched. She stalked to the table and splashed cognac into a glass. ‘Wife he adores?’ she mimicked tartly. ‘Why should "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("my")]), _vm._v(" son be saddled with such a barren mouse? Had he and Constance wed he would have had children. She has already borne a fine daughter. I would bet a florin to get a crown she has many sturdy sons in her, too. It is not to be borne that William might have no heir.’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page26"
    }
  }, [_vm._v("‘If he can bear it, my dear, I do not see why you cannot,’ Alexander suggested drily. ‘William and June have been married not yet four years; not so long when you think on it. Perchance they might prefer these early honeymoon years just for the two ")]), _c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_vm._v("of them. They have plenty of time to start their family. In a decade they might have a sizeable brood.’")])]), _c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Pamela squinted at her spouse over the rim of a glass. ‘What romantic drivel!’ She gulped at her drink and coughed. ‘Of course it is important to start one’s family soon. She might first produce a quartet of daughters, as did her mother. She might need a half-dozen attempts before successfully producing a son. When one is well connected, one understands the great importance of continuing a noble blood-line,’ she impressed on him, waving her empty glass.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Ah, I might have known mention would eventually be made of the ducal connection. Your great-uncle on the distaff side might be a landed duke, but he is better known as a common sot. He has beggared himself in brothels and gaming houses, as well you know. The fact he has no male heir to inherit his debts and debauchery can only benefit society.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Pamela, with tipsy gravity, smoothed her wispy hair, then licked the residue of alcohol from her desiccated lips. ‘I have no intention of letting you rile me. You have long been envious of my superior lineage, I know.’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_vm._v("‘You mistake the matter, my dear,’ Alexander corrected quietly. ‘What I have long coveted is my son’s wisdom, for Lord knows how he did it with such wilful obstruction, but he managed to find himself ")]), _c('a', {
    attrs: {
      "id": "page28"
    }
  }, [_vm._v("the perfect wife.’ Alexander caught up his coat in a smooth snatch and closed the drawing-room door quietly as he retired to his chamber.")])]), _c('a', {
    attrs: {
      "id": "page28"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Pamela stared after him for a long moment, her mouth compressed to a thin line. She went to the decanter and refilled her glass, then sought the warmth of the fire. The red in her cheeks had little to do with its glow.")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Edgar Meredith took his wife into his arms. ‘Come…come now, hush. I might have been mistaken. I wish I had not mentioned it to you at all.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Gloria Meredith accepted the linen handkerchief proffered by her husband and dried her hot eyes, her leaky nose. ‘I’m glad you did, Edgar.’ She sorrowfully shook her head. ‘I cannot believe it. It seems that the whole "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ton")]), _vm._v(" knows more about the state of one of my daughter’s marriages than do I. I thought Constance Bingham just a silly fool. I thought her fawning over William nothing to worry about.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘It "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("is")]), _vm._v(" nothing to worry about, my dear—’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page28"
    }
  }, [_vm._v("‘How can you say that! There is gossip everywhere about a divorce, you say. And June and William looked to be at loggerheads this evening. At one point I’m sure they were arguing. Then they barely made time to come over and take their leave before they had gone. If they stayed an hour at the ")]), _c('a', {
    attrs: {
      "id": "page29"
    }
  }, [_vm._v("Cleggs’ I should be surprised.’ Gloria pressed the damp linen to her freshly streaming eyes.")])]), _c('a', {
    attrs: {
      "id": "page29"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I did not say the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("whole world")]), _vm._v(" knows of it,’ Edgar cooed. ‘I overheard a conversation between two gentlemen in Boodle’s and they were denouncing Harley’s malicious lies as absurd. Most sensible people will dismiss them thus.’ Edgar paused, a thoughtful look putting a crease between his eyes. ‘But William is bound to be rightly furious when he finds out he and June are being pilloried. I hope he does not call Harley out…and he might with such provocation. He is a quiet gentleman; but then a mild manner sometimes conceals quite a dangerous adversary. I know he can fence and, if he shoots a pistol as well as he does a shotgun—he bagged more pheasant than any of us at Michaelmas—Harley will regret ever opening his mouth.’ Edgar’s enthusiasm for his son-in-law’s sporting prowess tailed off as he heard his wife’s unhappy little gurgle. ‘There, there…dry your tears. Harley and his buck-toothed crony are just risible idiots, everybody says so.’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page29"
    }
  }, [_vm._v("Edgar continued patting comfortingly at his wife’s fingers until the tears glistening in her eyes were blinked away. ‘Harley has never forgiven us since Connor made out of him a laughing stock over that game of cards, when I staked Windrush at the tables.’ At his wife’s piercing look of accusation, Edgar hurried on. ‘Of course I would never have let him ")]), _c('a', {
    attrs: {
      "id": "page30"
    }
  }, [_vm._v("have it. I would have sobered up well enough to cheat if necessary to keep our home. But I knew Connor wouldn’t let me down. He won the estate fair and square.’")])]), _c('a', {
    attrs: {
      "id": "page30"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘It is as well "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("that")]), _vm._v(" son-in-law is also a fine gentleman, for I doubt many people would return such an asset to a man silly enough to lose it in the first place.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Yes…well…all in the past, all in the past…’ Edgar quickly changed the subject, for the one he had stupidly settled on was a contretemps best forgotten. He relinquished past disasters and returned to the current family crisis. ‘Harley would love to concoct a scandal about one of our daughters that was plausible enough to do us all harm.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Gloria scrubbed her wet eyes. Oddly, the mention of other problems that had beset the Merediths rallied her courage. They had seen off trouble before and grown stronger for it. She sat straighter, and tapped lightly at the hand that rested on her arm, indicating Edgar’s soothing was no longer required.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Creakily her husband straightened from his position, squatting by her chair.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page30"
    }
  }, [_vm._v("‘I suspect Harley and Darlington are not alone in weaving this tapestry of lies. Perhaps a female hand is dabbling in it too,’ Gloria said with a meaningful squint at Edgar. ‘Tomorrow I will call on Pamela Pemberton and she will see me if I have to loiter in ")]), _c('a', {
    attrs: {
      "id": "page31"
    }
  }, [_vm._v("her hallway all day. She has never accepted June, yet June has been unwavering in her loyalty. Just the other day June gave Rachel a scold for calling her mother-in-law a mean-spirited witch—an accurate description if ever I heard one. Naturally, I told Rachel off too, for it doesn’t do to be "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("blatantly")]), _vm._v(" disrespectful.’ Gloria frowned in puzzlement. ‘But then I wouldn’t suppose she wished to expose her own son to scandal.’")])]), _c('a', {
    attrs: {
      "id": "page31"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Edgar expressed his bewilderment with a long face.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Tomorrow I "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("am")]), _vm._v(" going to see her.’ Gloria blew her nose with some force and a pugnacious glint fired her bloodshot eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I think that unwise, Gloria,’ her husband advised sagely. He took a turn about the sitting room, thoughtfully quiet. ‘If William has heard the latest rumours, I dare say he is fuming. But to put your mind at rest I shall make it my business to see "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("him.")]), _vm._v(" A little man-to-man chat is in order, I think.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("His wife appeared unconvinced of the success of that.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Tongues would really start wagging if you ladies engaged in a cat fight over it all,’ Edgar warned with a grin. ‘And should Rachel insist in going along with you, that might just come to pass. You know what a vixen she can be when protecting her family.’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page31"
    }
  }, [_vm._v("‘I don’t think she would do that, Edgar,’ Gloria an")]), _c('a', {
    attrs: {
      "id": "page32"
    }
  }, [_vm._v("nounced softly. ‘Not now she is again increasing. I have not yet had an opportunity to tell you my glad tidings, so engrossed have we been in your bad news. I learned from Rachel just this evening that we are to be grandparents again. Catherine is to have a brother or sister and Marcus and Lydia are to have another cousin.’ The mention of all their beautiful grandchildren at last put a smile on Gloria’s lips. ‘Isn’t that wonderful news?’")])]), _c('a', {
    attrs: {
      "id": "page32"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Edgar beamed. ‘Capital!’ he breathed. ‘Little wonder Connor is looking so uncommonly pleased with himself of late. When is the babe due?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Rachel thinks about September.’ Gloria’s expression became wistful. ‘I know June will be so very pleased for Rachel and Connor, yet I fear to mention it to her. I know she says little on the subject, but I’m sure she would dearly love to announce similar news.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘And so she shall, so she "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("shall")]), _vm._v(", my dear,’ Edgar quietly, confidently assured his wife. ‘All in good time June will have her family, you’ll see.’ He sighed. ‘Of course, the mischief Harley is brewing is hardly likely to help at all with filling their nursery. It would need to be a most harmonious couple who could remain unaffected by learning there is a wager on the time of their divorce.’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page32"
    }
  }, [_vm._v("Edgar put a finger to his lips, deep in thought. ‘As I see it, the problem—if it is one—is that June and ")]), _c('a', {
    attrs: {
      "id": "page33"
    }
  }, [_vm._v("William are two people too nice for their own good. June has always been determined to be kind to all and sundry, even the undeserving, and her husband is the sort of fellow who would oblige you with his last sovereign. Such sweet-natured folk are bound to frustrate those malcontents who thrive on ill will.’")])]), _c('a', {
    attrs: {
      "id": "page33"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Gloria nodded agreement. ‘Well, you may speak to the men first, but if nothing is done I will pay a visit on Pamela Pemberton. I will not have my June humiliated. I like William very much but he ought show his mettle over this.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘He is looking grim; I feel sure his patience is at an end over it all,’ Edgar championed his son-in-law.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I noticed this evening he looked irritable,’ Gloria said. ‘I hope they have not gone home early simply to quarrel…’")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("With a tender sigh June buried her head against her husband’s neck. A small hand slid over the hard ridges of muscle on his naked chest. Sated with pleasure, she slipped one of her silken legs between the brawny strength of William’s, then sensually caressed it up and down. The fond tribute to his artful lovemaking made her husband angle his head and place a gentle kiss on her small nose.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I’m sorry I was disagreeable earlier,’ June whispered against warm skin.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page33"
    }
  }, [_vm._v("‘I would have you disagreeable every day if this ")]), _c('a', {
    attrs: {
      "id": "page34"
    }
  }, [_vm._v("is how you apologise for it,’ William answered huskily. With gentle urgency he lifted her atop him and a hard hungry kiss reinforced the words. ‘Why have we not done this for so long? Why have you made excuses for so long? I have been mad with desire for you.’")])]), _c('a', {
    attrs: {
      "id": "page34"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I think you know the answer to that,’ June muttered with a touch of acerbity.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Constance Bingham is no threat to you, my love. She is probably desirous of a little flattery to boost her confidence now her mourning is at an end and she is again socialising. Soon she will be turning her attention to a more appreciative and unattached recipient. But…you would not have me act rudely towards her?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘No! Of course not,’ June said. ‘It is just…I’m not sure she "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("will")]), _vm._v(" turn her attention elsewhere. Besides, I rather think your mother might be disappointed if she did. I get the impression Pamela likes Lady Bingham. She regrets not having her as her daughter-in-law.’ June pushed back from William, her fine hair draping his chest in a blanket of silk. ‘I did not know that Constance Bingham is the Miss Palmer to whom you once were engaged. I would rather not have learned that from your mother. Why did "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("you")]), _vm._v(" not tell me?’ she demanded raggedly.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page34"
    }
  }, [_vm._v("William smoothed a finger over a pale cheek. ‘Why would I mention anything so insignificant? ")]), _c('a', {
    attrs: {
      "id": "page35"
    }
  }, [_vm._v("You are talking of a betrothal that ended over a decade ago. Our relationship endured for less than four months…or perhaps it was five. I cannot now recall.’ A careless grimace transformed effortlessly into a fond smile. ‘In the fullness of time I found you and I married you. I have no regrets at all. I love you.’")])]), _c('a', {
    attrs: {
      "id": "page35"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Once you loved Constance.’ When silence was all the response she got, June probed. ‘You did, didn’t you? Or was it a convenient match?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I’m not sure there was love between us, but it would have been financially convenient…’ He sighed and put a hand across his eyes. ‘I don’t see that there is any point in pondering the matter now, June. I was barely twenty…still a green boy. The matter is finished.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Perhaps Constance would like to revive it. Perhaps your mother would like that, too. Lady Bingham has a daughter. One of the reasons you mother is disappointed with me is because you are not yet a father.’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page35"
    }
  }, [_vm._v("William sat up, lifting his wife with him so she was settled on his lap, enclosed in a warm embrace, while he rocked her soothingly. The memory of his mother’s bitter words over June’s failure to conceive had simply fired his disgust for her and his protectiveness for June. ‘If—when, God willing, we have children, then it will be wonderful…for us.’ He gave his wife a seductive smile. ‘Perhaps it is just that we ")]), _c('a', {
    attrs: {
      "id": "page36"
    }
  }, [_vm._v("need a little more practice to get it right. I might let you persuade me to try again now…’ He smothered his wife’s laughing response with his mouth as he lowered them both back to the bed.")])]), _c('a', {
    attrs: {
      "id": "page36"
    }
  }, [_c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Hours later in the dark, June whispered, ‘Are you awake?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Her husband grunted a sleepy response.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I have been thinking…we should not let malicious people intimidate us. We shall not scuttle away to Grove House,’ she said, mentioning their country estate in Essex. ‘We shall stay here, and enjoy the season and socialise with whomsoever we please. We have nothing to be ashamed of.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("William murmured assent and cuddled his wife against his shoulder before whispering, ‘Very well… Now, unless you are prepared to practise again…go to sleep.’")])])]), _c('a', {
    attrs: {
      "id": "page36"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page36"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f24eac0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781459225282_ch02.vue
// module id = 78
// module chunks = 0